import { useAuthorization } from "~/hooks/useAuthorization";
import { useHireEsignatureFlag } from "~/hooks/useHireEsignatureFlag";

/**
 * Who reaches Settings → E-signature: an Owner or Admin, like the offer
 * settings pages. It ships under the `hireEsignature` release flag, because
 * e-signature for offers is its only use today.
 *
 * One answer for the nav item, the routes and the page, so they can't disagree.
 */
export function useCanConfigureIntegrations(): boolean {
  const { permissions } = useAuthorization();
  const eSignatureReleased = useHireEsignatureFlag();
  return Boolean(
    permissions.product?.hire &&
    permissions.integrations?.configure &&
    eSignatureReleased,
  );
}
